import { render, staticRenderFns } from "./GameStore.vue?vue&type=template&id=72f60c1a"
import script from "./GameStore.vue?vue&type=script&lang=js"
export * from "./GameStore.vue?vue&type=script&lang=js"
import style0 from "./GameStore.vue?vue&type=style&index=0&id=72f60c1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports